import React from "react";
import MainLayout from "../../layouts/MainPage";
import { GetRole, GetUserStandard } from "../../utils/RolesandAccess";
import UseGetData from "../../hooks/useFetchData";
import { DoughWithData, DoughWithNoData } from "../../utils/DoughNutChart";
import { MainDashboardLoader } from "../../components/Loader";

function Dashboard() {
  const { data, isLoading } = UseGetData({
    url: "/DashBoard/standard/overallPercentage",
  });

  function genStatusData(statusData) {
    let finalData = {
      completed: statusData?.completed || 0,
      in_progress: statusData?.in_progress || 0,
      yet_to_start: statusData?.yet_to_start || 0,
    };
    let returnValue = {
      label: [],
      data: [],
    };
    let X = Object.keys(finalData);
    let Y = Object.values(finalData);
    returnValue.label = X;
    returnValue.data = Y;

    let sum = Y.reduce((accumulator, currentValue) => {
      return accumulator + currentValue;
    }, 0);

    if (sum != 0) {
      return <DoughWithData dataWithLabel={returnValue} />;
    } else {
      return <DoughWithNoData />;
    }
  }

  return (
    <MainLayout dashboard={true}>
      <div className=" w-full p-4">
        {/* <div className=" flex gap-2 items-center mb-2">
        <h2 className="text-xl font-medium ">Dashboard</h2>
      </div> */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  xl:grid-cols-4 gap-[11px]">
          
          {GetRole() ? (
            <>
              {isLoading == true ? (
                <>
                {[...Array(8)].map((_, index) => {
                  return <MainDashboardLoader key={index} />;
                })}
                </>
              ) : (
                <>
                  {data &&
                    data.map((i, idx) => {
                      return (
                        <TempComponent
                          i={i}
                          genStatusData={genStatusData}
                          key={idx}
                        />
                      );
                    })}
                </>
              )}
            </>
          ) : (
            <>
              {isLoading == true ? (
                <>
                {[...Array(8)].map((_, index) => {
                  return <MainDashboardLoader key={index} />;
                })}
                </>
              ) : (
                <>
                  {data &&
                    data
                      .filter((item) =>
                        GetUserStandard().includes(item?.standard_id)
                      )
                      .map((i, idx) => {
                        return (
                          <TempComponent
                            i={i}
                            genStatusData={genStatusData}
                            key={idx}
                          />
                        );
                      })}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </MainLayout>
  );
}

export default Dashboard;

function TempComponent({ i, genStatusData }) {
  let completed = Number(i?.completed || 0);
  let completedValue = completed.toFixed(1);
  let yetToStart = Number(i?.yet_to_start || 0);
  let yetToStartValue = yetToStart.toFixed(1);
  let inProgress = Number(i?.in_progress || 0);
  let inProgressValue = inProgress.toFixed(1);
  return (
    <div className="px-4 py-2 rounded-[20px] shadow-main">
      {/* {i.id && getData(i.id)} */}

      <div className="text-right text-[10px] h-32  font-normal text-[#B9B7B7] py-1 flex justify-between items-center gap-3">
        <div className=" w-1/2 h-full overflow-hidden flex  flex-col justify-center items-center">
          <div className=" w-[60%] h-[100%] overflow-hidden mx-auto flex justify-center items-center">
            <img
              src={i.image_path}
              style={{ height: "calc(14vh - 28px)", width: "auto" }}
              alt="#"
            />
          </div>
          <h4 className="text-[#7030A0] h-[15%] font-extrabold text-[12px]">
            {i.name}
          </h4>
        </div>
        <div className=" w-1/2 h-full flex justify-center items-center">
          <div className=" w-24 h-24">{genStatusData(i)}</div>
        </div>
      </div>
      <div className=" flex items-center justify-between">
        <div>
          <div
            title=""
            className=" text-center text-[10px] px-[10px] py-2 font-semibold text-[#FF0000] "
          >
            <p>Yet To Start</p>
            <p className=" text-[11px]">{yetToStartValue || 0} %</p>
          </div>
        </div>
        <div>
          <p
            title=""
            className=" text-center text-[10px] px-[10px] py-2 font-semibold text-[#ffd700] "
          >
            <p>In Progress</p>
            <p className=" text-[11px]">{inProgressValue || 0} %</p>
          </p>
        </div>
        <div>
          <p
            title=""
            className=" text-center text-[10px] px-[10px] py-2 font-semibold text-[#008000] "
          >
            <p>Completed</p>
            <p className=" text-[11px]">{completedValue || 0} %</p>
          </p>
        </div>
      </div>
    </div>
  );
}
